<template lang="pug">
li.league-card
  a(data-toggle='tab' :href="'#' + source.id" :class="{ 'active' : selectedMatch == source.matchId}" @click.prevent="setMenu(source.matchId)")
    .match-info(:class="{ 'live' : source.marketId == 3 || [41, 42, 43, 44, 47].includes(source.sportsId) }")
      .d-flex.match-info-team
        .match-info-home-name.pl-1(:class="source.details['team'] == 1 ? 'team-red' : 'team-black'")
          .foul-card(v-if="source.matchBody[24] > 0 && source.matchBody[4] == 3")
            img(:src="'/images/red-card/red-card_' + source.matchBody[24] + '.svg?v=12'")
          .name.more-match-name {{ source.homeTeam }}
        TimePanel(:source="source")
        .match-info-away-name.pr-1(:class="source.details['team'] == 0 ? 'team-red' : 'team-black'")
          .name.more-match-name {{ source.awayTeam }}
          .foul-card(v-if="source.matchBody[25] > 0 && source.matchBody[4] == 3")
            img(:src="'/images/red-card/red-card_' + source.matchBody[25] + '.svg?v=12'")
</template>


<script>
import TimePanel from "@/components/mobile/main/timePanel";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    TimePanel
  },
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object
    }
  },
  computed: {
    selectedMatch() {
      return this.$store.getters.selectedMatch;
    }
  },
  watch: {
    selectedMatch(newVal) {
      if (newVal !== this.source.matchId) {
        return;
      }
      this.scrollActiveIntoView();
    }
  },
  mounted() {
    if (this.selectedMatch !== this.source.matchId) {
      return;
    }
    this.scrollActiveIntoView();
    // One retry after images / league list may finish laying out
    this._scrollRetryTimer = setTimeout(() => {
      this.scrollActiveIntoView();
    }, 400);
  },
  beforeDestroy() {
    if (this._scrollRetryTimer) {
      clearTimeout(this._scrollRetryTimer);
    }
  },
  methods: {
    scrollActiveIntoView() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const anchor = this.$el && this.$el.querySelector("a");
            if (!anchor) {
              return;
            }
            anchor.scrollIntoView({ inline: "center", block: "nearest", behavior: "auto" });
          });
        });
      });
    },
    setMenu(matchId) {
      if (this.selectedMatch === matchId) {
        return;
      }
      this.$store.dispatch("layout/setSelectedMatch", matchId);
      this.$store.dispatch("layout/setSelectedMatchMore", this.source);
      EventBus.$emit("MORE_MATCH_SWITCH");
      EventBus.$emit("GET_MATCH2");
    }
  }
}
</script>